import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress, useTheme } from '@mui/material';
import { ErrorsViewer } from './Errors';
import { FlexGrowRow } from './FlexBox';
const CoverProgress = (props) => {
    var _a;
    const { paper = true, open, opacity = 0.25, errors, onRetry } = props;
    const theme = useTheme();
    if (open) {
        return (_jsx(FlexGrowRow, Object.assign({ position: "absolute", margin: -1, top: 0, bottom: 0, right: 0, left: 0, bgcolor: paper ? theme.palette.background.paper : theme.palette.background.default }, { children: ((_a = errors === null || errors === void 0 ? void 0 : errors.length) !== null && _a !== void 0 ? _a : 0) === 0 ? (_jsx(CircularProgress, { style: { opacity } }, void 0)) : (_jsx(ErrorsViewer, { margin: 1, errors: errors, onRetry: onRetry }, void 0)) }), void 0));
    }
    return null;
};
export default CoverProgress;
//# sourceMappingURL=CoverProgress.js.map